import RefImportForm from './RefImportForm';

const ReferentialImport = {
  form: RefImportForm
};

export default RefImportForm;
